import React from 'react';

import './WarningMessage.less';

interface WarningMessageProps {
  title: string;
  detail: string | string[];
  isList?: boolean;
  style?: React.CSSProperties;
}

function WarningMessage({
  title,
  detail,
  isList,
  style = { maxWidth: '30em' },
}: WarningMessageProps): React.ReactElement {
  const afficherDetails = (detailList: string[]) =>
    isList ? (
      <ul className="detailList">
        {detailList.map(d => (
          <li key={d}>{d}</li>
        ))}
      </ul>
    ) : (
      detailList.map(d => <p key={d}>{d}</p>)
    );

  return (
    <div className="WarningMessage" style={style}>
      <h4 className="Title">{title}</h4>
      <div>{detail instanceof Array ? afficherDetails(detail) : detail}</div>
    </div>
  );
}

export default WarningMessage;
